export default __webpack_public_path__ + "assets/qr-code-advantages-easy-menu.0522e2fd.svg";